<template>
  <el-select ref="select" v-bind="$attrs" @change="onChange">
    <el-option
      v-for="item in itemOptions"
      :key="item.Id"
      :value="item.Code"
      :label="item.Name"
    />
  </el-select>
</template>

<script>
export default {
  data() {
    return {
      itemOptions: [],
    };
  },
  props: {
    type: { type: String, default: null, require: true },
  },
  created() {
    this.$apis.system.meta
      .itemList({ typeId: this.type })
      .then((res) => {
        this.itemOptions = res;
      })
      .catch((e) => {
        this.$message.error(e);
      });
  },
  methods: {
    onChange(val) {
      this.$emit("update:value", val);
      this.$nextTick(() => {
        let text = this.$refs.select.selectedLabel;
        this.$emit("change", text);
      });
    },
  },
};
</script>

